import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { updateStatusApi } from "../services/api";
 
const Redirect = () => {
  const navigate = useNavigate();
 
  const [loading, setLoading] = useState(true);
  const queryParams = new URLSearchParams(window.location.search);
 
  const params = {};
  for (const [key, value] of queryParams.entries()) {
    params[key] = value;
  }
 
  const UpdateMessage = async () => {
    console.log("update message called");
    try {
      const data = {
        message: params.message,
        reason: params.error,
        ext_ref: params.requestid,
      };
      const res = await axios.post(updateStatusApi, data);
      console.log(res);
    } catch (err) {
      console.log(err);
    }
  };
 
  useEffect(() => {
    const handleRedirect = async () => {
      try {
        await UpdateMessage();
        if (params?.message?.toLowerCase() === "success") {
          setTimeout(() => {
            navigate("/");
          }, 5000);
        } else {
          setLoading(false);
        }
      } catch (err) {
        console.log(err);
        setLoading(false);
      }
    };
 
    handleRedirect();
  }, []);
 
  // 1. Loader UI (Success Path)
  if (loading && params?.message?.toLowerCase() === "success") {
    return (
      <div className="min-h-screen bg-[#07080A] flex flex-col items-center justify-center p-5 font-sans relative">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.015)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.015)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none z-0" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[30vw] h-[30vw] rounded-full bg-[#FFEE00]/10 blur-[100px] pointer-events-none z-0" />
        
        <div className="relative z-10 flex flex-col items-center gap-6">
          <div className="w-16 h-16 rounded-full border-[4px] border-white/5 border-t-[#FFEE00] animate-spin shadow-[0_0_20px_rgba(255,238,0,0.3)]" />
          <h2 className="text-[#FFEE00] text-xl sm:text-2xl font-black uppercase tracking-[0.2em] animate-pulse">
            Activating Subscription...
          </h2>
          <p className="text-[#8A8B95] text-xs font-bold uppercase tracking-widest mt-2">
            Please do not close this page
          </p>
        </div>
      </div>
    );
  }
 
  // 2. Failure UI (Failure Path)
  return (
    <div className="min-h-screen bg-[#07080A] flex flex-col items-center justify-center p-5 font-sans relative">
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.015)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.015)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none z-0" />
      
      {params?.message?.toLowerCase() === "failure" && (
        <div className="bg-[#12131A] rounded-[32px] border border-white/5 p-10 sm:p-14 w-full max-w-[440px] relative z-10 flex flex-col items-center text-center shadow-2xl">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full rounded-full bg-[#FF007F]/10 blur-[80px] pointer-events-none z-0" />
          
          <div className="relative z-10">
            {/* Warning Icon */}
            <div className="w-20 h-20 bg-[#FF007F]/10 border border-[#FF007F]/20 rounded-full flex items-center justify-center mx-auto mb-8 shadow-[0_0_30px_rgba(255,0,127,0.2)]">
              <span className="text-4xl">⚠️</span>
            </div>
            
            <h2 className="text-3xl font-black text-white uppercase tracking-widest mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Subscription <span className="text-[#FF007F]">Failed</span>
            </h2>
            
            <p className="text-sm font-bold text-[#8A8B95] uppercase tracking-widest leading-relaxed">
              We couldn't process your request.
              <br className="my-2" />
              Try again later!
            </p>
            
            <button 
              onClick={() => navigate('/')}
              className="mt-10 px-8 py-4 bg-white/5 hover:bg-white/10 text-white text-xs font-black uppercase tracking-widest rounded-xl transition-all border border-white/10 w-full"
            >
              Return Home
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
 
export default Redirect;
